(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[82484,7797,5783,56012,75978,91058,99257,59654,55004,6050,12701,59679,54223,19341,33051,33030,6169,13054,59544,54042],{

/***/ 70731:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_SwiperNavButton; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ./UI/components/SwiperNavButton/utils/useSwiperNavButton.js



var useSwiperNavButton = function(_param) {
    var buttonRef = _param.buttonRef, type = _param.type, text = _param.text, className = _param.className, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "buttonRef",
        "type",
        "text",
        "className"
    ]);
    var svgType = type === "next" ? "arrowRight" : "arrowLeft";
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, rest), {
        buttonRef: buttonRef,
        type: type,
        text: text,
        svgType: svgType,
        className: className
    });
};

// EXTERNAL MODULE: ./UI/components/SwiperNavButton/styles.module.scss
var styles_module = __webpack_require__(5713);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./UI/components/SwiperNavButton/index.jsx









var Svg = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 6778).then(__webpack_require__.bind(__webpack_require__, 6778));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(6778)
            ];
        }
    }
});
var SwiperNavButton = function(props) {
    var _ref = useSwiperNavButton(props), buttonRef = _ref.buttonRef, type = _ref.type, text = _ref.text, svgType = _ref.svgType, className = _ref.className, rest = (0,_object_without_properties/* default */.Z)(_ref, [
        "buttonRef",
        "type",
        "text",
        "svgType",
        "className"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        type: "button",
        className: classnames_default()(className, (styles_module_default()).navButton, (styles_module_default())[type]),
        ref: buttonRef,
        "data-swiper-button": true
    }, rest), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg, {
                type: svgType
            }),
            text && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: (styles_module_default()).text,
                children: text
            })
        ]
    }));
};
SwiperNavButton.defaultProps = {
    className: "",
    text: ""
};
SwiperNavButton.propTypes = {
    type: prop_types_default().oneOf([
        "next",
        "prev"
    ]).isRequired,
    text: (prop_types_default()).string,
    className: (prop_types_default()).string
};
/* harmony default export */ var components_SwiperNavButton = (SwiperNavButton);


/***/ }),

/***/ 59654:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _utils_useTypography__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18422);






var Typography = function(props) {
    var _ref = (0,_utils_useTypography__WEBPACK_IMPORTED_MODULE_1__/* .useTypography */ .tj)(props), Tag = _ref.Tag, classes = _ref.classes, children = _ref.children, onClick = _ref.onClick, tabIndex = _ref.tabIndex, role = _ref.role, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_ref, [
        "Tag",
        "classes",
        "children",
        "onClick",
        "tabIndex",
        "role"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Tag, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        className: classes,
        onClick: onClick,
        tabIndex: tabIndex,
        role: role
    }, rest), {
        children: children
    }));
};
Typography.defaultProps = {
    variant: _utils_useTypography__WEBPACK_IMPORTED_MODULE_1__/* .TYPOGRAPHY_TAGS.p */ .w1.p,
    size: _utils_useTypography__WEBPACK_IMPORTED_MODULE_1__/* .TYPOGRAPHY_SIZE.paragrapgh16 */ .y3.paragrapgh16
};
Typography.propTypes = {
    children: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().node.isRequired),
    isBold: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().bool),
    variant: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
    className: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
    size: prop_types__WEBPACK_IMPORTED_MODULE_5___default().oneOf(Object.values(_utils_useTypography__WEBPACK_IMPORTED_MODULE_1__/* .TYPOGRAPHY_SIZE */ .y3)),
    mobileSize: prop_types__WEBPACK_IMPORTED_MODULE_5___default().oneOf(Object.values(_utils_useTypography__WEBPACK_IMPORTED_MODULE_1__/* .TYPOGRAPHY_SIZE */ .y3)),
    onClick: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().func),
    tabIndex: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
    role: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string)
};
/* harmony default export */ __webpack_exports__["default"] = (Typography);


/***/ }),

/***/ 18422:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "tj": function() { return /* binding */ useTypography; },
/* harmony export */   "w1": function() { return /* binding */ TYPOGRAPHY_TAGS; },
/* harmony export */   "y3": function() { return /* binding */ TYPOGRAPHY_SIZE; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2664);
/* harmony import */ var redux_selectors_layout__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19341);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(34461);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_4__);







var TYPOGRAPHY_TAGS = {
    h1: "h1",
    h2: "h2",
    h3: "h3",
    h4: "h4",
    h5: "h5",
    h6: "h6",
    p: "p",
    span: "span"
};
var TYPOGRAPHY_SIZE = {
    caption12: "caption",
    paragrapgh14: "paragrapgh-s",
    paragrapgh16: "paragrapgh-m",
    headline20: "headline-xs",
    headline24: "headline-s",
    headline38: "headline-m",
    headline46: "headline-l",
    headline56: "headline-xl"
};
var useTypography = function(_param) {
    var variant = _param.variant, isBold = _param.isBold, className = _param.className, children = _param.children, size = _param.size, mobileSize = _param.mobileSize, onClick = _param.onClick, tabIndex = _param.tabIndex, role = _param.role, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "variant",
        "isBold",
        "className",
        "children",
        "size",
        "mobileSize",
        "onClick",
        "tabIndex",
        "role"
    ]);
    var isDesktopResolution = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__.useSelector)(redux_selectors_layout__WEBPACK_IMPORTED_MODULE_3__/* .selectIsDesktop */ .Y6);
    var Tag = TYPOGRAPHY_TAGS[variant] || variant;
    var actualSize = isDesktopResolution || !mobileSize ? size : mobileSize;
    var classes = classnames__WEBPACK_IMPORTED_MODULE_0___default()((_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default().typography), className, (_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default())[actualSize], (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, (_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default().boldText), isBold));
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        Tag: Tag,
        children: children,
        classes: classes,
        onClick: onClick,
        tabIndex: tabIndex,
        role: role
    }, rest);
};


/***/ }),

/***/ 33051:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ containers_CustomSwiper; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 15 modules
var swiper_react = __webpack_require__(30719);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.esm.js + 92 modules
var swiper_esm = __webpack_require__(44040);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./UI/components/SwiperNavButton/index.jsx + 1 modules
var SwiperNavButton = __webpack_require__(70731);
// EXTERNAL MODULE: ./UI/components/SwiperNavigation/styles.module.scss
var styles_module = __webpack_require__(35133);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./UI/components/SwiperNavigation/index.jsx





var SwiperNavigation = function(param) {
    var className = param.className, navigationPrevRef = param.navigationPrevRef, navigationNextRef = param.navigationNextRef;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()(className, (styles_module_default()).navigationContainer),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SwiperNavButton/* default */.Z, {
                type: "prev",
                text: "previous",
                buttonRef: navigationPrevRef
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SwiperNavButton/* default */.Z, {
                type: "next",
                text: "next",
                buttonRef: navigationNextRef
            })
        ]
    });
};
SwiperNavigation.defaultProps = {
    className: null
};
SwiperNavigation.propTypes = {
    className: (prop_types_default()).string
};

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./UI/containers/CustomSwiper/utils/useCustomSwiper.js

var useCustomSwiper = function(param) {
    var children = param.children, swiperParams = param.swiperParams, isShowNavigation = param.isShowNavigation, navigationClassName = param.navigationClassName, className = param.className;
    var navigationPrevRef = (0,react.useRef)(null);
    var navigationNextRef = (0,react.useRef)(null);
    var onSwiperInit = function(swiper) {
        swiper.params.navigation.prevEl = navigationPrevRef.current;
        swiper.params.navigation.nextEl = navigationNextRef.current;
        swiper.navigation.init();
        swiper.navigation.update();
    };
    return {
        children: children,
        swiperParams: swiperParams,
        isShowNavigation: isShowNavigation,
        navigationClassName: navigationClassName,
        className: className,
        navigationPrevRef: navigationPrevRef,
        navigationNextRef: navigationNextRef,
        onSwiperInit: onSwiperInit
    };
};

// EXTERNAL MODULE: ./node_modules/swiper/swiper.min.css
var swiper_min = __webpack_require__(30933);
// EXTERNAL MODULE: ./node_modules/swiper/modules/navigation/navigation.min.css
var navigation_min = __webpack_require__(92);
// EXTERNAL MODULE: ./node_modules/swiper/modules/pagination/pagination.min.css
var pagination_min = __webpack_require__(68770);
// EXTERNAL MODULE: ./node_modules/swiper/modules/scrollbar/scrollbar.min.css
var scrollbar_min = __webpack_require__(13390);
// EXTERNAL MODULE: ./node_modules/swiper/modules/free-mode/free-mode.min.css
var free_mode_min = __webpack_require__(30706);
;// CONCATENATED MODULE: ./UI/containers/CustomSwiper/index.jsx














var CustomSwiper = function(props) {
    var ref = useCustomSwiper(props), children = ref.children, swiperParams = ref.swiperParams, isShowNavigation = ref.isShowNavigation, navigationClassName = ref.navigationClassName, className = ref.className, navigationNextRef = ref.navigationNextRef, navigationPrevRef = ref.navigationPrevRef, onSwiperInit = ref.onSwiperInit;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(swiper_react/* Swiper */.tq, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, swiperParams), {
        onInit: isShowNavigation ? onSwiperInit : undefined,
        modules: (0,_to_consumable_array/* default */.Z)(swiperParams.modules || []).concat([
            swiper_esm/* Navigation */.W_, 
        ]),
        className: className,
        children: [
            children,
            isShowNavigation && /*#__PURE__*/ (0,jsx_runtime.jsx)(SwiperNavigation, {
                className: navigationClassName,
                navigationPrevRef: navigationPrevRef,
                navigationNextRef: navigationNextRef
            })
        ]
    }));
};
SwiperNavigation.defaultProps = {
    isShowNavigation: false,
    navigationClassName: null
};
SwiperNavigation.propTypes = {
    isShowNavigation: (prop_types_default()).bool,
    navigationClassName: (prop_types_default()).string,
    swiperParams: prop_types_default().instanceOf(Object),
    children: prop_types_default().arrayOf((prop_types_default()).node)
};
/* harmony default export */ var containers_CustomSwiper = (CustomSwiper);


/***/ }),

/***/ 67974:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ sections_GallerySection; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 15 modules
var swiper_react = __webpack_require__(30719);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./UI/containers/CustomSwiper/index.jsx + 2 modules
var CustomSwiper = __webpack_require__(33051);
// EXTERNAL MODULE: ./UI/components/SectionTitle/index.jsx
var SectionTitle = __webpack_require__(15805);
// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ./utils/helper.js
var helper = __webpack_require__(6572);
;// CONCATENATED MODULE: ./UI/sections/GallerySection/utils/useGallerySection.js


var useGallerySection = function(param) {
    var type = param.type, sectionData = param.sectionData, handleOnCTAClick = param.handleOnCTAClick;
    var ref = (0,helper/* getDocumentFields */.OA)(sectionData, [
        "title",
        "description",
        "contentModules",
        "view", 
    ]), title = ref.title, description = ref.description, contentModules = ref.contentModules, view = ref.view;
    var galleryData = get_default()(contentModules, "[0]", {});
    var ref1 = (0,helper/* getDocumentFields */.OA)(galleryData, [
        "contentModules"
    ]), slides = ref1.contentModules;
    var ctaData = get_default()(contentModules, "[1]", null);
    return {
        view: view,
        type: type,
        title: title,
        description: description,
        slides: slides,
        handleOnCTAClick: handleOnCTAClick,
        ctaData: ctaData
    };
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.esm.js + 92 modules
var swiper_esm = __webpack_require__(44040);
;// CONCATENATED MODULE: ./UI/sections/GallerySection/utils/helpers.js



var swiperGalleryParams = {
    effect: "coverflow",
    slidesPerView: 1.1,
    centeredSlides: true,
    loop: true,
    passiveListeners: true,
    speed: 500,
    spaceBetween: 20,
    mousewheel: {
        forceToAxis: true
    },
    coverflowEffect: {
        rotate: 0,
        stretch: -40,
        depth: 150,
        slideShadows: false
    },
    breakpoints: {
        568: {
            slidesPerView: 1.3
        },
        768: {
            slidesPerView: 1.4,
            spaceBetween: 30
        },
        1024: {
            slidesPerView: 1.8,
            spaceBetween: 32
        }
    },
    modules: [
        swiper_esm/* EffectCoverflow */.lI,
        swiper_esm/* Pagination */.tl,
        swiper_esm/* Mousewheel */.Gk,
        swiper_esm/* Navigation */.W_, 
    ]
};
var typedSwiperParams = {
    "why-us": (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, swiperGalleryParams), {
        slidesPerView: 1,
        spaceBetween: 0,
        breakpoints: {
            1024: {
                slidesPerView: 1,
                spaceBetween: 0
            }
        }
    })
};
var singleParams = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, swiperGalleryParams), {
    loop: false
});

// EXTERNAL MODULE: ./UI/sections/GallerySection/styles.module.scss
var styles_module = __webpack_require__(62091);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./UI/sections/GallerySection/index.jsx










var ItemPreview = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 32505).then(__webpack_require__.bind(__webpack_require__, 32505));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(32505)
            ];
        }
    }
});
var CallToAction = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 49617).then(__webpack_require__.bind(__webpack_require__, 49617));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(49617)
            ];
        }
    }
});
var GallerySection = function(props) {
    var ref = useGallerySection(props), type = ref.type, view = ref.view, title = ref.title, description = ref.description, slides = ref.slides, handleOnCTAClick = ref.handleOnCTAClick, ctaData = ref.ctaData;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: classnames_default()((styles_module_default())[type], (styles_module_default()).section, (styles_module_default())[view]),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (styles_module_default()).gallerySection,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionTitle["default"], {
                        title: title,
                        description: description,
                        className: (styles_module_default()).sectionTitle
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomSwiper["default"], {
                        swiperParams: slides.lenght > 1 ? typedSwiperParams[type] || swiperGalleryParams : singleParams,
                        className: (styles_module_default()).slider,
                        isShowNavigation: slides.lenght > 1,
                        navigationClassName: (styles_module_default()).navigation,
                        children: slides === null || slides === void 0 ? void 0 : slides.map(function(slide, i) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemPreview, {
                                    data: slide,
                                    type: type
                                })
                            }, "gallery-section/".concat(i));
                        })
                    })
                ]
            }),
            ctaData && /*#__PURE__*/ (0,jsx_runtime.jsx)(CallToAction, {
                className: (styles_module_default()).callToAction,
                handleOnClick: handleOnCTAClick,
                data: ctaData
            })
        ]
    });
};
GallerySection.defaultProps = {
    handleOnCTAClick: function() {}
};
GallerySection.propTypes = {
    sectionData: prop_types_default().instanceOf(Object).isRequired,
    type: (prop_types_default()).string.isRequired,
    handleOnCTAClick: (prop_types_default()).func
};
/* harmony default export */ var sections_GallerySection = (GallerySection);


/***/ }),

/***/ 19341:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Bw": function() { return /* binding */ selectIsSmallTablet; },
/* harmony export */   "Tr": function() { return /* binding */ selectIsPageReadyToDisplay; },
/* harmony export */   "Y6": function() { return /* binding */ selectIsDesktop; },
/* harmony export */   "aT": function() { return /* binding */ selectIsTablet; },
/* harmony export */   "cF": function() { return /* binding */ selectIsFirstPageLoaded; },
/* harmony export */   "eD": function() { return /* binding */ selectIsMobile; },
/* harmony export */   "qL": function() { return /* binding */ selectIsMobileCategotiesOpened; }
/* harmony export */ });
var selectIsMobileCategotiesOpened = function(state) {
    return state.layout.isMobileCategotiesOpened;
};
var selectIsPageReadyToDisplay = function(state) {
    return state.layout.isPageReadyToDisplay;
};
var selectIsFirstPageLoaded = function(state) {
    return state.layout.isFirstPageLoaded;
};
var selectIsMobile = function(state) {
    return state.layout.isMobileResolution;
};
var selectIsTablet = function(state) {
    return state.layout.isTabletResolution;
};
var selectIsSmallTablet = function(state) {
    return state.layout.isSmallTabletResolution;
};
var selectIsDesktop = function(state) {
    return state.layout.isDesktopResolution;
};


/***/ }),

/***/ 5713:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"navButton":"styles_navButton___E8aQ","text":"styles_text__fy5hq","next":"styles_next__89xlm"};

/***/ }),

/***/ 35133:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"navigationContainer":"styles_navigationContainer__cgD9j"};

/***/ }),

/***/ 34461:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"boldText":"styles_boldText__iI9uz","headline-xl":"styles_headline-xl__HRBMS","headline-l":"styles_headline-l__Veh_x","headline-m":"styles_headline-m__gfh2N","headline-s":"styles_headline-s___kodX","headline-xs":"styles_headline-xs__XhN56","paragrapgh-m":"styles_paragrapgh-m__QFKni","paragrapgh-s":"styles_paragrapgh-s__4Eq1X","caption":"styles_caption__y7HHJ"};

/***/ }),

/***/ 62091:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"cardsWithFullWidthImage":"styles_cardsWithFullWidthImage__BQX3l","cards":"styles_cards__zdWC4","imageWrapper":"styles_imageWrapper__1VT_O","typeTitle":"styles_typeTitle__tZWAl","greySection":"styles_greySection__mo2LW","callToAction":"styles_callToAction__q7t5k","threeColumnsCards":"styles_threeColumnsCards__xZCCt","twoColumnsCards":"styles_twoColumnsCards__WwgQI","textContent":"styles_textContent__NCpyr","section":"styles_section__aCCn6","slider":"styles_slider__8tHSe","navigation":"styles_navigation___0cGD","android-mobile-app-development-services":"styles_android-mobile-app-development-services__lCTGT","sectionTitle":"styles_sectionTitle__o3rXr","artificial-intelligence-development-services":"styles_artificial-intelligence-development-services__ywk6e","discovery-phase-services":"styles_discovery-phase-services__VqgFT","mobile-app-development-company":"styles_mobile-app-development-company__4q7_k","chat-app-development-company":"styles_chat-app-development-company__eruqI","machine-learning-development-services":"styles_machine-learning-development-services__cGO6T","mvp-app-development-company":"styles_mvp-app-development-company___bKMn","cross-platform-development-services":"styles_cross-platform-development-services__TH9_c","banking-software-development-company":"styles_banking-software-development-company__u6VTL","crowdfunding-platform-development-company":"styles_crowdfunding-platform-development-company__Pu4wp","payment-gateway-development-company":"styles_payment-gateway-development-company__MsKop","pwa-development-services":"styles_pwa-development-services__L583M","billing-software-development-services":"styles_billing-software-development-services__3CWye","book-a-call":"styles_book-a-call__mRgYk","firstSectionView":"styles_firstSectionView__JN_qp","why-us":"styles_why-us__4lgn1","software-development-columbus":"styles_software-development-columbus__dqSMe","software-development-new-orleans":"styles_software-development-new-orleans__4kPP3","software-development-tulsa":"styles_software-development-tulsa__6c_FT","software-development-minneapolis":"styles_software-development-minneapolis__XZl9N","software-development-miami":"styles_software-development-miami__dJy2A","software-development-washington":"styles_software-development-washington__uLBfg","software-development-oklahoma":"styles_software-development-oklahoma__vvzyO","software-development-omaha":"styles_software-development-omaha__PKzL_","software-development-nashville":"styles_software-development-nashville__o1nDy","software-development-raleigh":"styles_software-development-raleigh__ZZO53","ai-software-development-services":"styles_ai-software-development-services___7Sni","e-commerce-development":"styles_e-commerce-development__i5yN_","entertainment-software-development-services":"styles_entertainment-software-development-services__PEyRI","healthcare-software-development-services":"styles_healthcare-software-development-services__gNVF4","ai-agent-development-services":"styles_ai-agent-development-services__0CyES","llm-development-services":"styles_llm-development-services__X6OUo","ai-voice-assistant-development-services":"styles_ai-voice-assistant-development-services__rD4Zr","ai-copilot-development-services":"styles_ai-copilot-development-services__4shGU","ai-staff-augmentation-services":"styles_ai-staff-augmentation-services__5jj3b","rag-development-services":"styles_rag-development-services__bQXoe","data-science-development-company":"styles_data-science-development-company__Zdu9Q","ai-consulting-services":"styles_ai-consulting-services__BuKuj","mlops-development-services":"styles_mlops-development-services__yErNp","ai-managed-pod":"styles_ai-managed-pod__y206K"};

/***/ }),

/***/ 30706:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 92:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 68770:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 13390:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 30933:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 31304:
/***/ (function(module) {


;(function (name, root, factory) {
  if (true) {
    module.exports = factory()
    module.exports["default"] = factory()
  }
  /* istanbul ignore next */
  else {}
}('slugify', this, function () {
  var charMap = JSON.parse('{"$":"dollar","%":"percent","&":"and","<":"less",">":"greater","|":"or","¢":"cent","£":"pound","¤":"currency","¥":"yen","©":"(c)","ª":"a","®":"(r)","º":"o","À":"A","Á":"A","Â":"A","Ã":"A","Ä":"A","Å":"A","Æ":"AE","Ç":"C","È":"E","É":"E","Ê":"E","Ë":"E","Ì":"I","Í":"I","Î":"I","Ï":"I","Ð":"D","Ñ":"N","Ò":"O","Ó":"O","Ô":"O","Õ":"O","Ö":"O","Ø":"O","Ù":"U","Ú":"U","Û":"U","Ü":"U","Ý":"Y","Þ":"TH","ß":"ss","à":"a","á":"a","â":"a","ã":"a","ä":"a","å":"a","æ":"ae","ç":"c","è":"e","é":"e","ê":"e","ë":"e","ì":"i","í":"i","î":"i","ï":"i","ð":"d","ñ":"n","ò":"o","ó":"o","ô":"o","õ":"o","ö":"o","ø":"o","ù":"u","ú":"u","û":"u","ü":"u","ý":"y","þ":"th","ÿ":"y","Ā":"A","ā":"a","Ă":"A","ă":"a","Ą":"A","ą":"a","Ć":"C","ć":"c","Č":"C","č":"c","Ď":"D","ď":"d","Đ":"DJ","đ":"dj","Ē":"E","ē":"e","Ė":"E","ė":"e","Ę":"e","ę":"e","Ě":"E","ě":"e","Ğ":"G","ğ":"g","Ģ":"G","ģ":"g","Ĩ":"I","ĩ":"i","Ī":"i","ī":"i","Į":"I","į":"i","İ":"I","ı":"i","Ķ":"k","ķ":"k","Ļ":"L","ļ":"l","Ľ":"L","ľ":"l","Ł":"L","ł":"l","Ń":"N","ń":"n","Ņ":"N","ņ":"n","Ň":"N","ň":"n","Ō":"O","ō":"o","Ő":"O","ő":"o","Œ":"OE","œ":"oe","Ŕ":"R","ŕ":"r","Ř":"R","ř":"r","Ś":"S","ś":"s","Ş":"S","ş":"s","Š":"S","š":"s","Ţ":"T","ţ":"t","Ť":"T","ť":"t","Ũ":"U","ũ":"u","Ū":"u","ū":"u","Ů":"U","ů":"u","Ű":"U","ű":"u","Ų":"U","ų":"u","Ŵ":"W","ŵ":"w","Ŷ":"Y","ŷ":"y","Ÿ":"Y","Ź":"Z","ź":"z","Ż":"Z","ż":"z","Ž":"Z","ž":"z","Ə":"E","ƒ":"f","Ơ":"O","ơ":"o","Ư":"U","ư":"u","ǈ":"LJ","ǉ":"lj","ǋ":"NJ","ǌ":"nj","Ș":"S","ș":"s","Ț":"T","ț":"t","ə":"e","˚":"o","Ά":"A","Έ":"E","Ή":"H","Ί":"I","Ό":"O","Ύ":"Y","Ώ":"W","ΐ":"i","Α":"A","Β":"B","Γ":"G","Δ":"D","Ε":"E","Ζ":"Z","Η":"H","Θ":"8","Ι":"I","Κ":"K","Λ":"L","Μ":"M","Ν":"N","Ξ":"3","Ο":"O","Π":"P","Ρ":"R","Σ":"S","Τ":"T","Υ":"Y","Φ":"F","Χ":"X","Ψ":"PS","Ω":"W","Ϊ":"I","Ϋ":"Y","ά":"a","έ":"e","ή":"h","ί":"i","ΰ":"y","α":"a","β":"b","γ":"g","δ":"d","ε":"e","ζ":"z","η":"h","θ":"8","ι":"i","κ":"k","λ":"l","μ":"m","ν":"n","ξ":"3","ο":"o","π":"p","ρ":"r","ς":"s","σ":"s","τ":"t","υ":"y","φ":"f","χ":"x","ψ":"ps","ω":"w","ϊ":"i","ϋ":"y","ό":"o","ύ":"y","ώ":"w","Ё":"Yo","Ђ":"DJ","Є":"Ye","І":"I","Ї":"Yi","Ј":"J","Љ":"LJ","Њ":"NJ","Ћ":"C","Џ":"DZ","А":"A","Б":"B","В":"V","Г":"G","Д":"D","Е":"E","Ж":"Zh","З":"Z","И":"I","Й":"J","К":"K","Л":"L","М":"M","Н":"N","О":"O","П":"P","Р":"R","С":"S","Т":"T","У":"U","Ф":"F","Х":"H","Ц":"C","Ч":"Ch","Ш":"Sh","Щ":"Sh","Ъ":"U","Ы":"Y","Ь":"","Э":"E","Ю":"Yu","Я":"Ya","а":"a","б":"b","в":"v","г":"g","д":"d","е":"e","ж":"zh","з":"z","и":"i","й":"j","к":"k","л":"l","м":"m","н":"n","о":"o","п":"p","р":"r","с":"s","т":"t","у":"u","ф":"f","х":"h","ц":"c","ч":"ch","ш":"sh","щ":"sh","ъ":"u","ы":"y","ь":"","э":"e","ю":"yu","я":"ya","ё":"yo","ђ":"dj","є":"ye","і":"i","ї":"yi","ј":"j","љ":"lj","њ":"nj","ћ":"c","ѝ":"u","џ":"dz","Ґ":"G","ґ":"g","Ғ":"GH","ғ":"gh","Қ":"KH","қ":"kh","Ң":"NG","ң":"ng","Ү":"UE","ү":"ue","Ұ":"U","ұ":"u","Һ":"H","һ":"h","Ә":"AE","ә":"ae","Ө":"OE","ө":"oe","Ա":"A","Բ":"B","Գ":"G","Դ":"D","Ե":"E","Զ":"Z","Է":"E\'","Ը":"Y\'","Թ":"T\'","Ժ":"JH","Ի":"I","Լ":"L","Խ":"X","Ծ":"C\'","Կ":"K","Հ":"H","Ձ":"D\'","Ղ":"GH","Ճ":"TW","Մ":"M","Յ":"Y","Ն":"N","Շ":"SH","Չ":"CH","Պ":"P","Ջ":"J","Ռ":"R\'","Ս":"S","Վ":"V","Տ":"T","Ր":"R","Ց":"C","Փ":"P\'","Ք":"Q\'","Օ":"O\'\'","Ֆ":"F","և":"EV","ء":"a","آ":"aa","أ":"a","ؤ":"u","إ":"i","ئ":"e","ا":"a","ب":"b","ة":"h","ت":"t","ث":"th","ج":"j","ح":"h","خ":"kh","د":"d","ذ":"th","ر":"r","ز":"z","س":"s","ش":"sh","ص":"s","ض":"dh","ط":"t","ظ":"z","ع":"a","غ":"gh","ف":"f","ق":"q","ك":"k","ل":"l","م":"m","ن":"n","ه":"h","و":"w","ى":"a","ي":"y","ً":"an","ٌ":"on","ٍ":"en","َ":"a","ُ":"u","ِ":"e","ْ":"","٠":"0","١":"1","٢":"2","٣":"3","٤":"4","٥":"5","٦":"6","٧":"7","٨":"8","٩":"9","پ":"p","چ":"ch","ژ":"zh","ک":"k","گ":"g","ی":"y","۰":"0","۱":"1","۲":"2","۳":"3","۴":"4","۵":"5","۶":"6","۷":"7","۸":"8","۹":"9","฿":"baht","ა":"a","ბ":"b","გ":"g","დ":"d","ე":"e","ვ":"v","ზ":"z","თ":"t","ი":"i","კ":"k","ლ":"l","მ":"m","ნ":"n","ო":"o","პ":"p","ჟ":"zh","რ":"r","ს":"s","ტ":"t","უ":"u","ფ":"f","ქ":"k","ღ":"gh","ყ":"q","შ":"sh","ჩ":"ch","ც":"ts","ძ":"dz","წ":"ts","ჭ":"ch","ხ":"kh","ჯ":"j","ჰ":"h","Ṣ":"S","ṣ":"s","Ẁ":"W","ẁ":"w","Ẃ":"W","ẃ":"w","Ẅ":"W","ẅ":"w","ẞ":"SS","Ạ":"A","ạ":"a","Ả":"A","ả":"a","Ấ":"A","ấ":"a","Ầ":"A","ầ":"a","Ẩ":"A","ẩ":"a","Ẫ":"A","ẫ":"a","Ậ":"A","ậ":"a","Ắ":"A","ắ":"a","Ằ":"A","ằ":"a","Ẳ":"A","ẳ":"a","Ẵ":"A","ẵ":"a","Ặ":"A","ặ":"a","Ẹ":"E","ẹ":"e","Ẻ":"E","ẻ":"e","Ẽ":"E","ẽ":"e","Ế":"E","ế":"e","Ề":"E","ề":"e","Ể":"E","ể":"e","Ễ":"E","ễ":"e","Ệ":"E","ệ":"e","Ỉ":"I","ỉ":"i","Ị":"I","ị":"i","Ọ":"O","ọ":"o","Ỏ":"O","ỏ":"o","Ố":"O","ố":"o","Ồ":"O","ồ":"o","Ổ":"O","ổ":"o","Ỗ":"O","ỗ":"o","Ộ":"O","ộ":"o","Ớ":"O","ớ":"o","Ờ":"O","ờ":"o","Ở":"O","ở":"o","Ỡ":"O","ỡ":"o","Ợ":"O","ợ":"o","Ụ":"U","ụ":"u","Ủ":"U","ủ":"u","Ứ":"U","ứ":"u","Ừ":"U","ừ":"u","Ử":"U","ử":"u","Ữ":"U","ữ":"u","Ự":"U","ự":"u","Ỳ":"Y","ỳ":"y","Ỵ":"Y","ỵ":"y","Ỷ":"Y","ỷ":"y","Ỹ":"Y","ỹ":"y","–":"-","‘":"\'","’":"\'","“":"\\\"","”":"\\\"","„":"\\\"","†":"+","•":"*","…":"...","₠":"ecu","₢":"cruzeiro","₣":"french franc","₤":"lira","₥":"mill","₦":"naira","₧":"peseta","₨":"rupee","₩":"won","₪":"new shequel","₫":"dong","€":"euro","₭":"kip","₮":"tugrik","₯":"drachma","₰":"penny","₱":"peso","₲":"guarani","₳":"austral","₴":"hryvnia","₵":"cedi","₸":"kazakhstani tenge","₹":"indian rupee","₺":"turkish lira","₽":"russian ruble","₿":"bitcoin","℠":"sm","™":"tm","∂":"d","∆":"delta","∑":"sum","∞":"infinity","♥":"love","元":"yuan","円":"yen","﷼":"rial","ﻵ":"laa","ﻷ":"laa","ﻹ":"lai","ﻻ":"la"}')
  var locales = JSON.parse('{"bg":{"Й":"Y","Ц":"Ts","Щ":"Sht","Ъ":"A","Ь":"Y","й":"y","ц":"ts","щ":"sht","ъ":"a","ь":"y"},"de":{"Ä":"AE","ä":"ae","Ö":"OE","ö":"oe","Ü":"UE","ü":"ue","ß":"ss","%":"prozent","&":"und","|":"oder","∑":"summe","∞":"unendlich","♥":"liebe"},"es":{"%":"por ciento","&":"y","<":"menor que",">":"mayor que","|":"o","¢":"centavos","£":"libras","¤":"moneda","₣":"francos","∑":"suma","∞":"infinito","♥":"amor"},"fr":{"%":"pourcent","&":"et","<":"plus petit",">":"plus grand","|":"ou","¢":"centime","£":"livre","¤":"devise","₣":"franc","∑":"somme","∞":"infini","♥":"amour"},"pt":{"%":"porcento","&":"e","<":"menor",">":"maior","|":"ou","¢":"centavo","∑":"soma","£":"libra","∞":"infinito","♥":"amor"},"uk":{"И":"Y","и":"y","Й":"Y","й":"y","Ц":"Ts","ц":"ts","Х":"Kh","х":"kh","Щ":"Shch","щ":"shch","Г":"H","г":"h"},"vi":{"Đ":"D","đ":"d"},"da":{"Ø":"OE","ø":"oe","Å":"AA","å":"aa","%":"procent","&":"og","|":"eller","$":"dollar","<":"mindre end",">":"større end"},"nb":{"&":"og","Å":"AA","Æ":"AE","Ø":"OE","å":"aa","æ":"ae","ø":"oe"},"it":{"&":"e"},"nl":{"&":"en"},"sv":{"&":"och","Å":"AA","Ä":"AE","Ö":"OE","å":"aa","ä":"ae","ö":"oe"}}')

  function replace (string, options) {
    if (typeof string !== 'string') {
      throw new Error('slugify: string argument expected')
    }

    options = (typeof options === 'string')
      ? {replacement: options}
      : options || {}

    var locale = locales[options.locale] || {}

    var replacement = options.replacement === undefined ? '-' : options.replacement

    var trim = options.trim === undefined ? true : options.trim

    var slug = string.normalize().split('')
      // replace characters based on charMap
      .reduce(function (result, ch) {
        var appendChar = locale[ch];
        if (appendChar === undefined) appendChar = charMap[ch];
        if (appendChar === undefined) appendChar = ch;
        if (appendChar === replacement) appendChar = ' ';
        return result + appendChar
          // remove not allowed characters
          .replace(options.remove || /[^\w\s$*_+~.()'"!\-:@]+/g, '')
      }, '');

    if (options.strict) {
      slug = slug.replace(/[^A-Za-z0-9\s]/g, '');
    }

    if (trim) {
      slug = slug.trim()
    }

    // Replace spaces with replacement character, treating multiple consecutive
    // spaces as a single space.
    slug = slug.replace(/\s+/g, replacement);

    if (options.lower) {
      slug = slug.toLowerCase()
    }

    return slug
  }

  replace.extend = function (customMap) {
    Object.assign(charMap, customMap)
  }

  return replace
}))


/***/ })

}]);